import { useCallback } from 'react'

export const useMergeRefs = <T>(...refs: React.Ref<T>[]): React.RefCallback<T> => {
  return useCallback(
    (element: T) => {
      refs.forEach((ref) => {
        if (typeof ref === 'function') {
          ref(element)
        } else if (ref) {
          // eslint-disable-next-line
          ;(ref as React.MutableRefObject<T | null>).current = element
        }
      })
    },
    [refs],
  )
}
